import { JourneyDataModel } from '../../../services/redux/features/journeyData.slice';
import { AddressFormModel_MX } from './formModel';

const mainCustomerRequestMapper = (values: AddressFormModel_MX): Partial<JourneyDataModel> => {
  return {
    address: {
      timeAtAddressFrom: values.timeAtAddressFrom,
    },
  };
};

const secondHirerRequestMapper = (values: AddressFormModel_MX): Partial<JourneyDataModel> => {
  return {
    secondHirer: {
      address: {
        timeAtAddressFrom: values.timeAtAddressFrom,
      },
    },
  };
};

export const requestMapper = (
  values: AddressFormModel_MX,
  isSecondHirer: boolean = false
): Partial<JourneyDataModel> => {
  return isSecondHirer ? secondHirerRequestMapper(values) : mainCustomerRequestMapper(values);
};
